enum CurrenciesEnum {
    USD = 1,
    EUR = 2,
    GBP = 3,
    CAD = 4,
    AUD = 5,
    JPY = 6,
    MXN = 7,
    COP = 8,
}

export default CurrenciesEnum;
